
<template>
    <div class="components-navbar">
        <div class="container">
            <div class="navbar-menu">
                <el-menu :default-active="route" class="el-menu" mode="horizontal" router menu-trigger="hover"
                    background-color="transition" text-color="#333333" active-text-color="#0060ff" ref="navbarMenuRef">
                    <template v-for="(menuItem, menuItemIndex) in menuItemArray">
                        <template v-if="menuItem.children.length !== 0">
                            <el-submenu :index="`${menuItemIndex}`" :key="'el-menu-item' + menuItemIndex">
                                <template slot="title">{{ menuItem.label }}</template>
                                <el-menu-item :index="`${children.activeIndex}`"
                                    v-for="(children, childrenIndex) in menuItem.children"
                                    :key="'el-menu-item' + childrenIndex">{{ children.label }}</el-menu-item>
                            </el-submenu>
                        </template>
                        <template v-else>
                            <el-menu-item :index="`${menuItem.activeIndex}`" :key="'el-menu-item' + menuItemIndex">
                                {{ menuItem.label }}
                            </el-menu-item>
                        </template>
                    </template>
                    <el-menu-item v-if="loginStatus">
                        <template>
                            <el-dropdown @command="handleCommand" trigger="click">
                                <span class="el-dropdown-link">
                                    {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="personalCenter">个人中心</el-dropdown-item>
                                    <el-dropdown-item command="exitLogin">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavbarComponentsVue",
    props: {
        userName: { type: String, default: () => { return "" }, required: true },
        isLogin: { type: Boolean, default: () => { return false; }, required: true }
    },
    data() {
        return {
            logoSrc: require("@/assets/qxr/logo.png"),
            loginStatus: false,
            menuItemArray: [
                { label: "首  页", activeIndex: "/index", children: [] },
                { label: "金融产品", activeIndex: "/products", children: [] },
                { label: "融资增信", activeIndex: "/service", children: [] },
                { label: "投资理财", activeIndex: "/investment", children: [] },
                { label: "金融机构", activeIndex: "/productsOrg", children: [] },
                { label: "拍卖拍租", activeIndex: "/assetsAuction", children: [] },
                { label: "招投标", activeIndex: "/assetsAuction2", children: [] },
                { label: "金融调解", activeIndex: "/mediation", children: [] },
                { label: "政策动态", activeIndex: "/information", children: [] },
                { label: "政策支持", activeIndex: "/policySupport", children: [] },

                // { label: "政策指南", activeIndex: "", children: [
                //     { label: '政策动态', activeIndex: '/information' },
                //     { label: '政策支持', activeIndex: '/policySupport' },
                // ] },

                {
                    label: "农资农情", activeIndex: "", children: [
                        { label: '农资信息', activeIndex: '/agriculturalList' },
                        { label: '农资农情', activeIndex: '/agriEmind' },
                    ]
                },
                {
                    label: "综合服务", activeIndex: "", children: [
                        { label: '项目合作', activeIndex: '/projectInteract' },
                        { label: '服务推荐', activeIndex: '/serviceRecommend' },
                    ]
                },
                { label: "关于我们", activeIndex: "/aboutus", children: [] }
            ],
        };
    },
    watch: {
        isLogin: {
            handler: function (newV, oldV) {
                this.$data.loginStatus = newV !== oldV ? newV : oldV
            },
            immediate: true
        }
    },
    computed: {
        route() {
            const route = this.$route
            const { meta, path } = route
            // 可以在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
            // meta中 有activeMenu 字段的子页面，都会显示高亮
            if (meta.activeMenu) {
                return `/${meta.activeMenu}`;
            }
            return path;
        }
    },
    methods: {
        handleCommand(val) {
            this.$emit("handleCommand", val);
        }
    },
};
</script>

<style lang="scss" scoped>
.components-navbar {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 50px;
    z-index: 999;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    .container,
    .navbar-menu,
    .el-menu--horizontal,
    .el-submenu {
        height: 100%;
    }
}
</style>

<style lang="scss">
.el-dropdown-menu.el-popper {
    padding: 10px;

    .login-dromdown-menu__item {
        width: 80px;
        height: 36px;
        color: #fff;
        line-height: 38px;
        text-align: center;
        padding-left: 50px;
        font-size: 12px;
        border-radius: 5px;

        &:not(:first-child) {
            margin-top: 5px;
        }

    }
}
</style>

<style lang="scss">
.components-navbar {
    .el-menu {
        li>.el-dropdown {
            color: #fff !important;
            font-size: 14px !important;
            font-weight: bold;
        }

        .el-menu-item i {
            color: #fff !important;
        }

        .el-menu-item:last-child {
            .el-dropdown-selfdefine {
                font-size: 14px;
            }

            & * {
                vertical-align: inherit;
            }
        }
    }
    .el-submenu__title{
      font-size: 14px !important;
      line-height: 50px !important;
    }

}
.components-navbar .el-menu--horizontal>.el-menu-item, .components-navbar .el-menu--horizontal>.el-submenu .el-submenu__title{
    font-size: 14px !important;
    line-height: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavbarComponents20231101.vue